import React from "react";
import {connect} from "react-redux";
import * as actions from "../../store/actions/index"
import RBCarousel from "react-bootstrap-carousel";
import { Row, Col, Button, ButtonGroup } from "./bootstrap-component.jsx";
import "react-bootstrap-carousel/dist/react-bootstrap-carousel";
import classes from "./Carousel.module.css"
const styles = { height: 400, width: "100%" };
const icon_glass = <span className="fa fa-glass" />;
const icon_music = <span className="fa fa-music" />;

class Carousel extends React.PureComponent {
  constructor(props) {
    super(props);
    this.slider = React.createRef();
    this.state = {
      autoplay: true,
    };
  }
  _onSelect = (active, direction) => {
    // console.log(`active=${active} && direction=${direction}`);
  };
  _visiableOnSelect = (active) => {
    console.log(`visiable onSelect active=${active}`);
  };
  _slideNext = () => {
    this.slider.current.slideNext();
  };
  _slidePrev = () => {
    this.slider.current.slidePrev();
  };
  _goToSlide = () => {
    this.slider.current.goToSlide(1);
  };
  _autoplay = () => {
    this.setState({ autoplay: !this.state.autoplay });
  };
  _changeIcon = () => {
    let { leftIcon, rightIcon } = this.state;
    leftIcon = leftIcon ? undefined : icon_glass;
    rightIcon = rightIcon ? undefined : icon_music;
    this.setState({ leftIcon, rightIcon });
  };
  componentDidMount = ()=>{
    this.props.fetCarouselData();
  } 
  render() {
      if(!this.props.carouselData){
        return null;
      }
      // console.log(this.props.carouselData)
    return (
      <div className="container-fluid" style={{ paddingBottom: 20 }}>
        <Row>
          {/* <Col span={12} style={{ paddingTop: "20px" }}>
            <ButtonGroup>
              <Button bsStyle="primary" onClick={this._slidePrev}>
                Slider prev
              </Button>
              <Button bsStyle="primary" onClick={this._slideNext}>
                Slider next
              </Button>
              <Button bsStyle="primary" onClick={this._goToSlide}>
                Go to slide 2
              </Button>
            </ButtonGroup>
          </Col>
          <Col span={12} style={{ paddingTop: "20px" }}>
            <ButtonGroup>
              <Button bsStyle="primary" onClick={this._changeIcon}>
                Change Icon
              </Button>
              <Button bsStyle="primary" onClick={this._autoplay}>
                {this.state.autoplay ? "Stop Autoplay" : "Start Autoplay"}
              </Button>
            </ButtonGroup>
          </Col> */}
          <Col span={12} style={{ marginTop: 20 }}>
            <RBCarousel
              animation={true}
              autoplay={this.state.autoplay}
              slideshowSpeed={2000}
              defaultActiveIndex={0}
              leftIcon={this.state.leftIcon}
              rightIcon={this.state.rightIcon}
              onSelect={this._onSelect}
              ref={this.slider}
              version={4}
            > 
              
            {
                this.props.carouselData&&this.props.carouselData.map(carousel=>(
                <div  className={classes.ImgDiv} key={Math.random()*100}>
                    <a  href={carousel.redirectUrl?carousel.redirectUrl:"#"}>
                      <img 
                      style={{ width: "100%", height: "100%" }}
                      // src="https://image.made-in-china.com/208f0j00AatTyFmdkQks/%E8%B7%91%E6%AD%A5%E6%9C%BABANNER1.jpg"
                      src={carousel.imgUrl}
                    />
                    </a>
                    {/* <div className="carousel-caption">Image</div> */}
                  </div>
                ))
            }
             
             
            </RBCarousel>
          </Col>
          {/* <Col span={12} style={{ marginTop: 20 }}>
            <RBCarousel
              autoplay={this.state.autoplay}
              pauseOnVisibility={true}
              onSelect={this._visiableOnSelect}
              slideshowSpeed={2000}
              version={4}
            >
              <div style={{ ...styles, backgroundColor: "lightblue" }}>
                <div className="carousel-center">
                  <div>This carsouel won't change if invisiable</div>
                  <div>pauseOnVisibility = true</div>
                </div>
                <div className="carousel-center"> </div>
                <div className="carousel-caption">Text</div>
              </div>
              <div style={{ ...styles, backgroundColor: "lightblue" }}>
                <div className="carousel-center">
                  <div>This carsouel won't change if invisiable</div>
                  <div>pauseOnVisibility = true</div>
                </div>
                <div className="carousel-caption">Text</div>
              </div>
            </RBCarousel>
          </Col>
          <Col span={12} style={{ marginTop: 20 }}>
            <RBCarousel className="carousel-fade" version={4}>
              <div style={{ ...styles, backgroundColor: "darkcyan" }}>
                <div className="carousel-center">
                  This carsouel transition is fade
                </div>
                <div className="carousel-caption">Text</div>
              </div>
              <div style={{ ...styles, backgroundColor: "yellowgreen" }}>
                <span className="carousel-center">
                  This carsouel transition is fade
                </span>
                <div className="carousel-caption">Text</div>
              </div>
            </RBCarousel>
          </Col> */}
        </Row>
      </div>
    );
  }
}
const mapStateToProps = state=>{
  return{
      carouselData:state.carouselData.carouselData
  }
}
const mapDispatchToProps = dispatch=>{
  return{
      fetCarouselData:()=>dispatch(actions.fetchCarouselData())
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(Carousel);
